import { render, staticRenderFns } from "./user-dataStatistics.vue?vue&type=template&id=5fa7bad0&scoped=true&"
import script from "./user-dataStatistics.vue?vue&type=script&lang=js&"
export * from "./user-dataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./user-dataStatistics.vue?vue&type=style&index=0&id=5fa7bad0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa7bad0",
  null
  
)

export default component.exports